import { useEffect, useState } from "react"

// Reactive matchMedia observation (P8-H6 "Pocket Door"). Messages and the Team
// workspace use it as useMediaQuery("(max-width: 720px)") so the view layer can
// gate the existing read calls on detail-pane VISIBILITY, not server-side
// selection (Temper TF-001): at phone width the auto-selected conversation's
// pane sits off-canvas, so its read must not fire until the customer explicitly
// opens it. The initial read is SSR-safe — no `window` means no match.
export default function useMediaQuery(query) {
  const [matches, setMatches] = useState(() =>
    typeof window !== "undefined" ? window.matchMedia(query).matches : false
  )

  useEffect(() => {
    const mql = window.matchMedia(query)
    setMatches(mql.matches)

    const onChange = (event) => setMatches(event.matches)
    mql.addEventListener("change", onChange)
    return () => mql.removeEventListener("change", onChange)
  }, [query])

  return matches
}
